import { useState } from "react";

import { Search, Select, GradientButton } from "../../components/forms";
import { PageContainer } from "../../components/PageComponents";
import { CountryIcon } from "../../assets/Icons";
import { Promotion, PromotionModal } from "./components";

const Promotions = () => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <PageContainer title="Promotions">
      <div className="flex flex-col md:flex-row items-stretch md:items-center gap-3 w-full mb-6">
        <div className="flex flex-col sm:grid sm:grid-cols-2 lg:flex lg:flex-row items-stretch lg:items-center gap-3 w-full mb-6">
          {/* Search - Takes full width on mobile, half width on tablet, and stretches on desktop */}
          <div className="col-span-2 lg:flex-1 w-full">
            <Search
              placeholder="Search by promotion name"
              onChange={() => {
                // Handle search input change
              }}
            />
          </div>

          {/* Select Filters Group */}
          <div className="flex flex-row items-center gap-3 w-full lg:w-auto col-span-1">
            <div className="flex-1 lg:flex-initial">
              <Select
                icon={<CountryIcon />}
                options={countrydata}
                type="filter"
              />
            </div>
            <div className="flex-1 lg:flex-initial">
              <Select options={statusData} type="filter" />
            </div>
          </div>

          {/* Action Button*/}
          <div className="w-full lg:w-auto col-span-1 flex items-end lg:items-center">
            <GradientButton
              content="Add new promo"
              onClick={() => setModalOpen(!modalOpen)}
              className="w-full lg:w-auto text-center justify-center h-12"
            />
          </div>
        </div>
      </div>

      <Promotion promotions={promotionData} />
      {modalOpen && <PromotionModal close={() => setModalOpen(!modalOpen)} />}
    </PageContainer>
  );
};

export default Promotions;

export const countrydata = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "India",
];

export const statusData = ["Expired", "Ongoing"];

const promotionData = [
  {
    id: 1,
    name: "First Time Purchase",
    promoCode: "DEA532KY",
    countries: "ng, gh, ke",
    valid: "No End",
    status: "Ongoing",
    discount: "20%",
    usage: 400,
    group: "First Time Users",
    link: "",
  },
  {
    id: 2,
    name: "Nigeria Sale Week",
    promoCode: "DEA532KY",
    countries: "ng, gh, ke",
    valid: "No End",
    status: "Ongoing",
    discount: "20%",
    usage: 400,
    group: "First Time Users",
    link: "",
  },
  {
    id: 3,
    name: "First Time Purchase",
    promoCode: "DEA532KY",
    countries: "ng, gh, ke",
    valid: "No End",
    status: "Expired",
    discount: "20%",
    usage: 400,
    group: "First Time Users",
    link: "",
  },
];
